import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, ButtonBase } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { useIntl } from 'react-intl';
import { DimensionObjectType } from '~/types';
import { useNotReferencedProjectRoleListStyles } from './styles';

export const NotReferencedProjectRoleList = ({
  roles,
  onAddClick,
  canAddRole,
  notFetchedRolesCount
}) => {
  const { formatMessage } = useIntl();
  const classes = useNotReferencedProjectRoleListStyles();
  const moreRolesText = formatMessage(
    {
      id: 'advancedRateCard.notReferencedProjectRoles.moreRoles'
    },
    {
      count: notFetchedRolesCount
    }
  );

  const handleAddClick = role => event => {
    event.stopPropagation();
    onAddClick?.(role, DimensionObjectType.ProjectRole);
  };

  return (
    <Grid container spacing={0} className={classes.grid}>
      {roles.map(role => (
        <Grid item xs={12} md={6} key={role.id}>
          {canAddRole ? (
            <ButtonBase
              component="div"
              className={classes.roleItemInteractive}
              onClick={handleAddClick(role)}
              focusRipple
            >
              <Typography variant="body2" className={classes.roleText}>
                {role.displayText}
              </Typography>
              <AddCircleIcon className={classes.addIcon} fontSize="small" />
            </ButtonBase>
          ) : (
            <div className={classes.roleItem}>
              <Typography variant="body2" className={classes.roleText}>
                {role.displayText}
              </Typography>
            </div>
          )}
        </Grid>
      ))}
      {notFetchedRolesCount > 0 ? (
        <Grid item xs={12} key="MORE_ROLES">
          <div className={classes.roleItem}>
            <Typography variant="body2" className={classes.moreRolesText}>
              {moreRolesText}
            </Typography>
          </div>
        </Grid>
      ) : null}
    </Grid>
  );
};

NotReferencedProjectRoleList.propTypes = {
  roles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      displayText: PropTypes.string.isRequired
    })
  ).isRequired,
  onAddClick: PropTypes.func,
  canAddRole: PropTypes.bool,
  notFetchedRolesCount: PropTypes.number
};

export default NotReferencedProjectRoleList;
